import axios from 'axios';

export const CONTENT_CMS = 'cms/contents/';
export const CONTENTS = 'cms/contents';
export const CONTENTS_CLONE = 'cms/contents-clone';

const CTTY_LEMONADE = 'CTTY_14';

export function getContent(guid) {
  return axios.get(`${CONTENTS}/${guid}`);
}

export function getContents(params) {
  return axios.get(CONTENTS, { params: { ...params, isEditorial: 1 } });
}

export function getActivities(params) {
  return getContents({ ...params, type: [CTTY_LEMONADE] });
}

export function createContent(params) {
  return axios.post(CONTENTS, params);
}

export function updateContent(params) {
  return axios.put(`${CONTENTS}/${params.guid}`, params);
}

export function deleteContent(params = { guid: [] }) {
  return axios.delete(CONTENTS, { data: params });
}

export function cloneContent(params) {
  return axios.post(CONTENTS_CLONE, params);
}

// --------------------------------------------------------------------------------
//  CREATE METADATA:
// --------------------------------------------------------------------------------

export function createContentEducationLevels(contentGuid, guids) {
  return axios.post(`${CONTENTS}/${contentGuid}/education-levels`, { guid: guids });
}

export function createContentEducationYears(contentGuid, guids) {
  return axios.post(`${CONTENTS}/${contentGuid}/education-years`, { guid: guids });
}

export function createContentDisciplines(contentGuid, guids) {
  return axios.post(`${CONTENTS}/${contentGuid}/disciplines`, { guid: guids });
}

export function createContentTags(contentGuid, guids) {
  return axios.post(`${CONTENTS}/${contentGuid}/tags`, { guid: guids });
}

export function createContentCollections(contentGuid, guids) {
  return axios.post(`${CONTENTS}/${contentGuid}/collections`, { guid: guids });
}

export function createContentPublications(contentGuid, guids) {
  return axios.post(`${CONTENTS}/${contentGuid}/publications`, { guid: guids });
}

export function createContentDependencies(contentGuid, guids) {
  return axios.post(`${CONTENTS}/${contentGuid}/dependencies`, { guid: guids });
}

export function createContentCustomTags(contentGuid, guids) {
  return axios.post(`${CONTENTS}/${contentGuid}/custom-tags`, { guid: guids });
}

// --------------------------------------------------------------------------------
//  DELETE METADATA:
// --------------------------------------------------------------------------------

export function deleteContentCustomTags(contentGuid, guids) {
  const params = { guid: guids };

  return axios.delete(`${CONTENTS}/${contentGuid}/custom-tags`, { data: params });
}

// --------------------------------------------------------------------------------
//  OTHER:
// --------------------------------------------------------------------------------

export function getContentCms(guid) {
  return axios.get(CONTENT_CMS + guid);
}

export function uploadFromGoogleDrive(contentGuid, fileId, oauthToken, innerFolder) {
  const params = { fileId: fileId, oauthToken: oauthToken };
  if (innerFolder && innerFolder.toString().length > 0) {
    params.innerFolder = innerFolder;
  }
  return axios.post(CONTENT_CMS + contentGuid + '/content/upload-from-google-drive', params);
}

export function uploadFromGoogleDriveThumbnail(contentGuid, fileId, oauthToken) {
  const params = { fileId: fileId, oauthToken: oauthToken };
  return axios.post(CONTENT_CMS + contentGuid + '/thumbnail/upload-from-google-drive', params);
}

// ---------------------------------------------------
//   SUBTITLES
// ---------------------------------------------------
/**
 * Crea un nuevo subtítulo para un contenido específico
 * @param {string} contentId - GUID del contenido
 * @param {object} params - Parámetros del subtítulo (file, name, language_id)
 * @returns {Promise} - Promesa con la respuesta del servidor
 */
export function createSubtitle(contentId, params) {
  return axios.post(`${CONTENTS}/${contentId}/subtitles`, params);
}

/**
 * Actualiza un subtítulo existente
 * @param {string} contentId - GUID del contenido
 * @param {string} subtitleId - ID del subtítulo a actualizar
 * @param {object} params - Parámetros actualizados (name, language_id)
 * @returns {Promise} - Promesa con la respuesta del servidor
 */
export function updateSubtitle(contentId, subtitleId, params) {
  return axios.put(`${CONTENTS}/${contentId}/subtitles/${subtitleId}`, params);
}

/**
 * Elimina uno o varios subtítulos de un contenido
 * @param {string} contentId - GUID del contenido
 * @param {object} params - Objeto con array de IDs de subtítulos a eliminar { id: [1, 2, 3] }
 * @returns {Promise} - Promesa con la respuesta del servidor
 */
export function deleteSubtitle(contentId, params = { id: [] }) {
  return axios.delete(`${CONTENTS}/${contentId}/subtitles`, { data: params });
}

// ---------------------------------------------------
//   AUDIODESCRIPTIONS
// ---------------------------------------------------
export function createAudiodescription(contentId, params) {
  return axios.post(`${CONTENTS}/${contentId}/audiodescriptions`, params);
}

export function updateAudiodescription(contentId, audiodescriptionId, params) {
  return axios.put(`${CONTENTS}/${contentId}/audiodescriptions/${audiodescriptionId}`, params);
}

export function deleteAudiodescription(contentId, params = { id: [] }) {
  return axios.delete(`${CONTENTS}/${contentId}/audiodescriptions`, { data: params });
}
